import { createSelector } from '@reduxjs/toolkit'

import { AUDIT_LOGS_REDUCER_NAME } from './consts'
import { RootState } from 'app/store'

export const auditLogsDataSelector = (state: RootState) =>
  state[AUDIT_LOGS_REDUCER_NAME]

export const auditLogsSelector = createSelector(
  auditLogsDataSelector,
  (auditLogsData) => auditLogsData?.logs
)

export const allLogsFetchedSelector = createSelector(
  auditLogsDataSelector,
  (auditLogsData) => auditLogsData?.allLogsFetched
)
